import { TabSwitcher } from "components/ui/TabSwitcher/TabSwitcher";
import { ConsultationBox } from "features/consultations/components/ConsultationBox";
import {
  BaselineTab,
  EmailTab,
  FormTab,
  LabOrderTab,
  LetterTab,
  NoteTab,
  PrescriptionTab,
  ReferralTab,
  SickCertTab,
  VaccineTab,
} from "features/consultations/components/tabs";
import { useActiveConsultation } from "features/consultations/hooks/useActiveConsultation";
import { useConsultationTabs } from "features/consultations/hooks/useConsultationTabs";
import { PatientDetailCard } from "features/patients/components/PatientDetailCard/index.js";
import { usePatientData } from "features/patients/hooks/usePatientData";
import { usePracticeSettings } from "features/practice/hooks/usePracticeSettings";
import { useStaffInfo } from "features/practice/hooks/useStaffInfo";

import { ConsultationsTable } from "../PatientConsultationsPage/components/ConsultationsTable/ConsultationsTable.jsx";
import s from "./PatientConsultPage.module.css";

export const PatientConsultPage = () => {
  usePracticeSettings();

  const { data: staffInfo } = useStaffInfo();
  const { data: patient } = usePatientData();
  const { data: activeConsultation } = useActiveConsultation(
    patient?.activeConsultationId
  );

  const staffName = staffInfo?.staffMember
    ? `${staffInfo.staffMember.firstName} ${staffInfo.staffMember.lastName}`
    : "";

  const { tab, setTab, tabOptions } = useConsultationTabs({
    hasEmail: true,
  });

  return (
    <>
      <div style={{ margin: "0 auto" }}>
        <div className={s.wrapper}>
          <div className={s.firstRowWrapper}>
            <div className={s.firstColumnWrapper}>
              <PatientDetailCard maxWidth={700} />
            </div>
            <div className={s.secondColumnWrapper}>
              <div className={s.secondColumnSubWrapper}>
                <ConsultationBox
                  patient={patient}
                  staffName={staffName}
                  consultation={activeConsultation}
                  onFinish={() => setTab("add-note")}
                />
              </div>
            </div>
          </div>
          <div className={s.secondRowWrapper}>
            <div className={s.consultationColumnWrapper}>
              {!!activeConsultation && (
                <div className={s.consultationWrapper}>
                  <div className={s.topWrapper}>
                    <h3 className={s.title}>Consultation</h3>
                    <TabSwitcher
                      options={tabOptions}
                      value={tab}
                      onChange={setTab}
                      withOverflow
                      fullWidth
                    />
                  </div>
                  {tab === "add-note" && (
                    <NoteTab
                      consultation={activeConsultation}
                      isDisabled={!activeConsultation}
                      staffName={staffName}
                      currentStaffMemberId={staffInfo?.staffMember?.id}
                    />
                  )}
                  {tab === "add-prescription" && (
                    <PrescriptionTab consultationId={activeConsultation?.id} />
                  )}
                  {tab === "add-vaccine" && (
                    <VaccineTab onSuccess={() => setTab("add-note")} />
                  )}
                  {tab === "add-baseline" && (
                    <BaselineTab
                      consultationId={activeConsultation?.id}
                      onSuccess={() => setTab("add-note")}
                    />
                  )}
                  {tab === "add-referral" && (
                    <ReferralTab
                      consultationId={activeConsultation?.id}
                      onSuccess={() => setTab("add-note")}
                    />
                  )}
                  {tab === "add-lab-order" && <LabOrderTab />}
                  {tab === "add-letter" && (
                    <LetterTab consultationId={activeConsultation?.id} />
                  )}
                  {tab === "add-sick-cert" && (
                    <SickCertTab consultationId={activeConsultation?.id} />
                  )}
                  {tab === "add-form" && (
                    <FormTab consultation={activeConsultation} />
                  )}
                  {tab === "send-email" && (
                    <EmailTab
                      consultationId={activeConsultation?.id}
                      onClose={() => setTab("add-note")}
                    />
                  )}
                </div>
              )}
              <div className={s.notesWrapper}>
                <div className={s.notesHeader}>
                  <h3 className={s.notesTitle}>
                    Other consultations for this patient
                  </h3>
                </div>
                <div className={s.notesContent}>
                  <ConsultationsTable
                    patientIdVal={patient?.id}
                    itemsPerPage={5}
                    currentConsultationId={activeConsultation?.id}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
